import styled, { css } from 'styled-components';
import { Typography } from 'ui';

type TriggerTabStyledProps = {
  $active: boolean;
};

export const ScheduleCronText = styled(Typography)`
  color: var(--color-primary1);
  cursor: pointer;
`;